/**
 * Purpose:
 *   Shared not-found view using BlankState for public and protected routes.
 * Notes:
 *   - Uses the common i18n namespace for UI copy
 *   - Leverages shared BlankState illustrations for empty results
 */
'use client';

import Link from 'next/link';
import { useTranslation } from 'react-i18next';
import { BlankState } from '@/components/ui/blankState';
import { notFoundStyles as styles } from './NotFoundContent.styles';

interface INotFoundContentProps {
  homeHref?: string;
}

export function NotFoundContent({ homeHref = '/' }: INotFoundContentProps) {
  const { t } = useTranslation('common');

  return (
    <div className={styles.container}>
      <BlankState type="error-404" message={t('not_found.message')} />
      <Link href={homeHref} prefetch={false} className={styles.cta}>
        {t('not_found.cta')}
      </Link>
    </div>
  );
}
